import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { ShieldCheck, Zap, Award } from 'lucide-react';
import { motion } from 'framer-motion';
export default function FinalCTA() {
  const scrollToPricing = () => {
    document.getElementById('comprar')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <Section className="bg-gradient-to-b from-brand-cream to-brand-cream-dark text-center pb-32" data-id="element-67">
      <div className="max-w-4xl mx-auto" data-id="element-68">
        <div className="inline-block bg-red-900/20 text-red-400 border border-red-900/30 px-4 py-1 rounded-full text-sm font-bold mb-6 animate-pulse" data-id="element-69">
          ÚLTIMA OPORTUNIDAD
        </div>

        <h2 className="text-3xl md:text-4xl text-white mb-6 font-light" data-id="element-70">
          Si hoy estás cansada de acostarte con miedo a tu propia cabeza…
        </h2>
        <p className="text-xl md:text-2xl text-slate-400 mb-12" data-id="element-71">
          y quieres que la cama deje de ser el lugar donde tu mente te ataca:
        </p>

        <div className="flex justify-center mb-12" data-id="element-72">
          <img src="https://cdn.magicpatterns.com/uploads/kqoAg16R5aAnzZRiRdtKG6/APAGA_LA_MENTE_COVER_2.png" alt="APAGA LA MENTE" className="w-64 md:w-80 animate-float drop-shadow-xl" data-id="element-73" />
        </div>

        <div className="mb-6 transform hover:scale-105 transition-transform duration-300" data-id="element-74">
          <Button size="xl" pulse={true} className="text-2xl md:text-3xl px-16 py-8 shadow-[0_0_40px_rgba(67,56,202,0.3)] hover:shadow-[0_0_60px_rgba(67,56,202,0.5)] transition-shadow duration-300" onClick={scrollToPricing} data-id="element-75">
            QUIERO MIS NOCHES DE VUELTA →
          </Button>
        </div>

        <p className="text-slate-400 text-base font-medium mb-2" data-id="element-76">
          Solo $6.39 — y nunca más «¿por qué no puedo dormir?»
        </p>

        <div className="flex flex-wrap justify-center gap-4 sm:gap-8 mb-12 text-slate-500 text-sm font-medium" data-id="element-77">
          <div className="flex items-center gap-2" data-id="element-78">
            <ShieldCheck size={16} className="text-brand-indigo" data-id="element-79" />
            <span data-id="element-80">Pago seguro</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-81">
            <Zap size={16} className="text-brand-amber" data-id="element-82" />
            <span data-id="element-83">Acceso inmediato</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-84">
            <Award size={16} className="text-brand-indigo" data-id="element-85" />
            <span data-id="element-86">Garantía 7 días</span>
          </div>
        </div>

        <p className="text-xl text-slate-500 mb-16" data-id="element-87">
          Decide una vez. Y deja que tus noches cambien.
        </p>

        <div className="relative inline-block" data-id="element-88">
          <h3 className="relative font-heading text-4xl md:text-6xl text-brand-amber leading-tight uppercase tracking-wide" data-id="element-89">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.1
          }} data-id="element-90">
              Menos pelea.
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.3
          }} data-id="element-91">
              Menos miedo.
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.5
          }} data-id="element-92">
              Más calma.
            </motion.div>
          </h3>
        </div>

        <p className="text-slate-500 text-sm mt-12" data-id="element-93">
          ★★★★★ Valorado por más de 600 personas
        </p>
      </div>
    </Section>;
}